// Temporary compatibility entry point while legacy payment consumers migrate into this feature.
export {
  initialErrorState,
  initialPaymentState,
  testCardPaymentState,
} from './state/initial-state';
